import React from 'react';
import { FaTrophy } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

import Azizlogo from '../images/azizlogo.png'
import Royalclub from '../images/Aziz Royal Club.png'
const Header = ({ winners = [] }) => {
    const navigate = useNavigate();

    const handleRegisterClick = () => {
        navigate('/register'); // This will navigate to your form page
    };

    return (
        <div className="bg-gradient-to-b from-black to-gray-800 p-4 sm:p-8 relative min-h-screen">
            
            <div className="flex justify-center mb-4">
                <img 
                    src={Azizlogo} 
                    alt="Aziz Logo" 
                    className="w-45 h-45 sm:w-35 sm:h-28 object-contain"
                />
            </div>
            <div className="flex justify-center ">
                <img 
                    src={Royalclub}
                    alt="Aziz Royal Club" 
                    className="w-[290px] h-auto sm:w-64 font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-yellow-500 to-yellow-300 tracking-wide drop-shadow-lg hover:scale-105 transition-transform duration-300 animate-pulse"
                />
            </div>
            
            {winners.length > 0 && (
                <div className="flex flex-row justify-center items-center gap-4 max-w-4xl mx-auto mt-[60px]">
                    {winners[0]?.name && (
                        <div className="transform hover:scale-105 transition-transform duration-300 w-full  sm:w-48">
                            <div className="bg-gradient-to-r from-yellow-500 to-yellow-400 rounded-xl p-6 shadow-lg border-2 border-yellow-600">
                                <div className="flex items-center justify-center mb-3">
                                    <FaTrophy className="text-4xl text-yellow-600" />
                                </div>
                                <h2 className="font-bold text-xl text-white mb-2">Mr.Foodie</h2>
                                <p className="text-gray-700 font-medium">{winners[0].name}</p>
                                
                            </div>
                        </div>
                    )}

                    {winners[1]?.name && (
                        <div className="transform hover:scale-105 transition-transform duration-300 w-full sm:w-48">
                            <div className="bg-gradient-to-r from-yellow-500 to-yellow-400 rounded-xl p-6 shadow-lg border-2 border-yellow-600">
                                <div className="flex items-center justify-center mb-3">
                                <FaTrophy className="text-4xl text-yellow-600" />
                                </div>
                                <h2 className="font-bold text-xl text-white mb-2">Mr.Foodie</h2>
                                <p className="text-gray-700 font-medium">{winners[1].name}</p>
                                
                            </div>
                        </div>
                    )}
                </div>
            )}
            
            <div className="mt-12 text-center">
                <div className="bg-gradient-to-r from-black to-gray-700 p-6 rounded-2xl shadow-xl max-w-2xl mx-auto border-2 border-yellow-600 backdrop-blur-sm">
                    <div className="mb-4">
                        {/* <span className="inline-block bg-yellow-400 text-blue-900 text-sm font-bold px-4 py-1 rounded-full mb-2 animate-pulse">
                            Next Event
                        </span> */}
                        <h2 className="text-2xl sm:text-3xl font-bold text-yellow-300 mb-12">
                            Royal Membership  👑
                        </h2>
                        {/* <p className="text-yellow-200 mb-4">
                            <span className="inline-block bg-yellow-600 px-4 py-2 rounded-lg">
                                🗓️ March 30th, 2024 • 2:00 PM GMT
                            </span>
                        </p> */}
                        <button 
                            onClick={handleRegisterClick}
                            className="bg-gradient-to-r from-yellow-400 to-yellow-500 hover:from-yellow-500 hover:to-yellow-600 text-blue-900 font-bold py-3 px-8 rounded-full transform hover:scale-105 transition-all duration-300 shadow-lg">
                            Register Now 🏆
                        </button>
                    </div>
                    <p className="text-yellow-200 text-sm">
                        Limited spots available! Don't miss your chance to compete
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Header;
